import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line

import LogoImage from "../../images/logoDynaskills.png";

import { ReactComponent as FacebookIcon } from "images/facebook-icon.svg";
import { ReactComponent as TwitterIcon } from "images/twitter-icon.svg";
import { ReactComponent as YoutubeIcon } from "images/youtube-icon.svg";
import { ReactComponent as SvgDecoratorBlob1 } from "images/svg-decorator-blob-9.svg";
import translate from "../../lang/translate";


const Container = tw.div`relative bg-tertiary text-secondary-500 font-bold -mb-8 -mx-8 px-8 py-20 lg:py-24`;
const Content = tw.div`max-w-screen-xl mx-auto relative z-10`;
const Row = tw.div`flex items-center justify-center flex-col px-8`

const LogoContainer = tw.div`flex items-center justify-center md:justify-start bg-white p-1 rounded-md`;
const LogoImg = tw.img`w-48`;

const LinksContainer = tw.div`mt-8  font-medium flex flex-wrap justify-center items-center flex-col sm:flex-row`
const Link = tw.a`text-secondary-500 border-b-2 border-transparent hocus:text-gray-300 hocus:border-gray-300 pb-1 transition duration-300 mt-2 mx-4`;

const SocialLinksContainer = tw.div`mt-10`;
const SocialLink = styled.a`
  ${tw`cursor-pointer inline-block text-gray-100 hover:text-gray-100 transition duration-300 mx-4 text-secondary-500`}
  svg {
    ${tw`w-5 h-5`}
  }
`;
const CopyrightText = tw.p`text-center mt-10 font-medium tracking-wide text-sm text-secondary-500`
const DecoratorBlobContainer = tw.div`absolute inset-0 overflow-hidden rounded-lg`;
const DecoratorBlob1 = tw(
  SvgDecoratorBlob1
)`absolute top-0 left-0 w-80 h-80 transform -translate-x-20 -translate-y-32 text-secondary-500 opacity-25`;
const DecoratorBlob2 = tw(
  SvgDecoratorBlob1
)`absolute bottom-0 right-0 w-80 h-80 transform  translate-x-32 translate-y-48 text-secondary-500 opacity-25`;


export default () => {
  return (
    <Container>
      <Content>
      <Row>
          <LogoContainer>
            <LogoImg src={LogoImage} />
          </LogoContainer>
          <LinksContainer>
            <Link href="/">{translate('header.home')}</Link>
            <Link href="/our-analyses">{translate('header.our_analyses')}</Link>
            <Link href="/about-us">{translate('header.about_us')}</Link>
            <Link href="/faq">{translate('header.help')}</Link>
            <Link href="/#contact_section">{translate('header.login')}</Link>
            <Link href="/#contact_section">{translate('header.sign_up')}</Link>
          </LinksContainer>
          <LinksContainer>
            <Link href="/privacy-policy">{translate('footer.privacy_policy')}</Link>
            <Link href="/terms-and-condition">{translate('footer.terms_condition')}</Link>
          </LinksContainer>
          <SocialLinksContainer>
            <SocialLink href="https://facebook.com">
              <FacebookIcon />
            </SocialLink>
            <SocialLink href="https://twitter.com">
              <TwitterIcon />
            </SocialLink>
            <SocialLink href="https://youtube.com">
              <YoutubeIcon />
            </SocialLink>
          </SocialLinksContainer>
          <CopyrightText>
            &copy; {translate('footer.copyright')}
          </CopyrightText>
        </Row>
      </Content>
      <DecoratorBlobContainer>
        <DecoratorBlob1 />
        <DecoratorBlob2 />
      </DecoratorBlobContainer>
      
    </Container>
  );
};
